// RetryInfoList.jsx
// Component displaying helpful information about the retry process

import React from 'react';
import { styles } from './styles';

const RetryInfoList = () => {
  const infoItems = [
    {
      icon: '💡',
      text: 'Your progress has been saved'
    },
    {
      icon: '🔒',
      text: 'Setup is secure with Stripe'
    },
    {
      icon: '⚡',
      text: 'Takes just a few minutes'
    }
  ];

  return (
    <div style={styles.infoContainer}>
      {infoItems.map((item, index) => (
        <div key={index} style={styles.infoItem}>
          <span style={styles.infoIcon}>{item.icon}</span>
          <span>{item.text}</span>
        </div>
      ))}
    </div>
  );
};

export default RetryInfoList;